// extracted by mini-css-extract-plugin
export default {"circle":"zhSndI","rotate":"saDfXf","clip":"swk6kW","clip-reverse":"negNZs","clipReverse":"negNZs"};